import { render, staticRenderFns } from "./couponWeapp.vue?vue&type=template&id=d324893c&scoped=true"
import script from "./couponWeapp.vue?vue&type=script&lang=js"
export * from "./couponWeapp.vue?vue&type=script&lang=js"
import style0 from "./couponWeapp.vue?vue&type=style&index=0&id=d324893c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d324893c",
  null
  
)

component.options.__file = "couponWeapp.vue"
export default component.exports